/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface MgmClaimRowDTO {
  assignedAt?: Date;
  cancelReason?: string;
  conqueredAt?: Date;
  eligibleAt?: Date;
  mgmMilestoneClaimId?: number;
  milestoneNumber?: number;
  milestoneTitle?: string;
  personId?: number;
  personName?: string;
  semestralAnualCount?: number;
  shippedAt?: Date;
  shippingOrderId?: number;
  status?: string;
  statusLabel?: string;
}
